<div class="certificate-form-container">
  <div class="certificate-form">
    <h3 class="form-title">Add New Certificate</h3>

    <form (ngSubmit)="onSubmit()">
      <!-- Certificate Name -->
      <div class="form-group">
        <label for="certName" class="form-label">
          Certificate Name <span class="required">*</span>
        </label>
        <input
          #nameInput
          type="text"
          id="certName"
          class="form-input"
          [(ngModel)]="formData.name"
          name="certName"
          placeholder="e.g., Azure Client Secret"
          [disabled]="isSubmitting"
          required
        />
      </div>

      <!-- Certificate Type -->
      <div class="form-group">
        <label for="certType" class="form-label">
          Type <span class="required">*</span>
        </label>
        <div class="radio-group">
          <label class="radio-label">
            <input
              type="radio"
              name="certType"
              [(ngModel)]="formData.type"
              value="Front"
              [disabled]="isSubmitting"
            />
            <span class="radio-text">Front</span>
          </label>
          <label class="radio-label">
            <input
              type="radio"
              name="certType"
              [(ngModel)]="formData.type"
              value="Back"
              [disabled]="isSubmitting"
            />
            <span class="radio-text">Back</span>
          </label>
        </div>
      </div>

      <!-- Environment Dates -->
      <div class="form-section">
        <p class="section-label">
          Expiration Dates
          <span class="section-hint"
            >(At least one environment is required)</span
          >
        </p>

        <div class="environments-grid">
          <div class="form-group">
            <label for="devDate" class="form-label">Dev</label>
            <input
              type="date"
              id="devDate"
              class="form-input"
              [(ngModel)]="formData.dev"
              name="devDate"
              [disabled]="isSubmitting"
            />
          </div>

          <div class="form-group">
            <label for="preprodDate" class="form-label">Preprod</label>
            <input
              type="date"
              id="preprodDate"
              class="form-input"
              [(ngModel)]="formData.preprod"
              name="preprodDate"
              [disabled]="isSubmitting"
            />
          </div>

          <div class="form-group">
            <label for="prodDate" class="form-label">Prod</label>
            <input
              type="date"
              id="prodDate"
              class="form-input"
              [(ngModel)]="formData.prod"
              name="prodDate"
              [disabled]="isSubmitting"
            />
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="button"
          class="cancel-button"
          (click)="onCancel()"
          [disabled]="isSubmitting"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="submit-button"
          [disabled]="!isValid || isSubmitting"
        >
          {{ isSubmitting ? "Adding..." : "Add Certificate" }}
        </button>
      </div>
    </form>
  </div>
</div>
